import * as types from './types';
import { SITE_MULTIPLIER } from 'Common/Constants';

const INITIAL_STATE = {
  sites: [],
  loading: false,
  fiscalYears: [],
  sitesLoading: false,
};

export default (state = INITIAL_STATE, { payload, type }) => {
  switch (type) {
    case types.CEP_SETUP_GET_SITES:
      return {
        ...state,
        sites: payload,
      };
    case types.CEP_SETUP_LOADING:
      return {
        ...state,
        loading: payload,
      };
    case types.CEP_SETUP_ERRORS:
      return {
        ...state,
        errors: payload,
      };
    case types.CEP_SETUP_GET_SITES_BY_FISCAL_YEAR:
      if (payload === 'Sites not found.') {
        return { ...state, sites: [] };
      }
      payload.forEach(site => {
        site.Multiplier = SITE_MULTIPLIER;
      });
      return {
        ...state,
        sites: payload,
        fiscalYear: payload[0] ? payload[0].fiscalYear : null,
      };
    case types.CEP_SETUP_GET_FISCAL_YEARS:
      let formattedYears = [];
      payload.data.forEach(element => {
        formattedYears.push({
          value: element,
          text: element.toString(),
        });
      });
      return {
        ...state,
        fiscalYears: formattedYears,
      };
    case types.CEP_SETUP_LOAD_SITES:
      return {
        ...state,
        sitesLoading: false,
      };
    default:
      return state;
  }
};



// WEBPACK FOOTER //
// ./src/pages/cepsetup/state/setup/reducer.js